var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_outline_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/info_outline_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 9.99984C1.6665 5.39984 5.39984 1.6665 9.99984 1.6665C14.5998 1.6665 18.3332 5.39984 18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 1.6665 14.5998 1.6665 9.99984ZM10.8332 9.1665V14.1665H9.1665V9.1665H10.8332ZM9.99984 16.6665C6.32484 16.6665 3.33317 13.6748 3.33317 9.99984C3.33317 6.32484 6.32484 3.33317 9.99984 3.33317C13.6748 3.33317 16.6665 6.32484 16.6665 9.99984C16.6665 13.6748 13.6748 16.6665 9.99984 16.6665ZM10.8332 5.83317V7.49984H9.1665V5.83317H10.8332Z",
    fill: "#326BDB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline24Px);
export default __webpack_public_path__ + "static/media/info_outline_24px.f897b89efa63b0ab25bd340115158446.svg";
export { ForwardRef as ReactComponent };